



























































import { Component, Mixins, Vue } from 'vue-property-decorator';
import GExamCreateFormFormat from '@/views/GExamCreate/GExamCreateFormFormat.vue';
import GExamCreateSpan from '@/views/GExamCreate/BaseSetting/GExamCreateBaseSettingDateSpan.vue';
import { GEnum } from '@/constants/enum.defination';
import GJgrowEventCreateBaseSetting from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateBaseSetting.vue';
import GJgrowEventCreateQuestionSetting from '@/views/GJgrowEventCreate/QuestionSetting/GJgrowEventCreateQuestionSetting.vue';
import GJgrowEventCreateExamieeSetting from '@/views/GJgrowEventCreate/ExamineeSetting/GJgrowEventCreateExamineeSetting.vue';
import GJgrowEventCreateConfirmViewSetting from '@/views/GJgrowEventCreate/ConfirmView/GJgrowEventCreateConfirmView.vue';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity } from '@/models/activity/activity';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { masterModule } from '@/store/modules/entities/master.module';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { Competency } from '@/models/competency/competency';
import { QuestionType } from '@/models/evalSetting/question-type';
import { required } from 'vuelidate/lib/validators';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { GPageBase } from '@/mixins';
import { SchoolClass } from '@/models/school-class/school-class';

Component.registerHooks(['beforeRouteLeave']);
@Component({
  name: 'GJgrowEventCreate',
  components: {
    GTitleBar,
    GCustomBreadCrumb,
    GJgrowEventCreateExamieeSetting,
    GJgrowEventCreateConfirmViewSetting,
    GJgrowEventCreateQuestionSetting,
    GJgrowEventCreateBaseSetting,
    GExamCreateSpan,
    GExamCreateFormFormat,
  },
  computed: {},
  methods: {},
  validations: {
    evalSettingDetail: {
      title: { required },
    },
  },
})
export default class GJgrowEventCreate extends Mixins(GPageBase) {
  title: string = '';
  competencySettingType: GEnum.CompetencySettingType = GEnum.CompetencySettingType.Full;
  eventID: number = 0;
  breadCrumbItems: BreadCrumbElement[] = [];
  lazy: boolean = false;

  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === 'jgrowEvent' && this.isAutoPageTransition) {
      // 登録後の受検一覧画面への自動遷移ではデータ喪失確認ダイアログは表示しない
      next();
    } else if (to.name === 'signin') {
      // ログアウトする場合には、データ喪失確認ダイアログは表示しない
      next();
    } else {
      this.openConfirm(
        //OK押下時は画面遷移を許容する
        () => {
          next();
        },
        () => {}
      );
    }
  }

  created() {
    jgrowEventCreateModule.setMode(Number(this.$route.query['mode']));
    this.eventID = Number(this.$route.query['eventID']);
  }

  async mounted() {
    //初期化
    jgrowEventCreateModule.clean();
    jgrowEventCreateModule.cleanCompetencySelections();
    //evalSettingModule.evalSettingDetail.clean();
    jgrowEventCreateModule.params.clean();

    //設問設定周りのリソース取得
    await masterModule.fetchQuestionType();
    await masterModule.fetchCompetency();
    await masterModule.fetchQuestionTypesWithCompetencies();
    masterModule.fetchCompetencySettingType();
    masterModule.fetchDestinations();

    //傾向チェックマスタデータ取得
    //masterModule.fetchTrends();

    //受検設定周りのリソース取得
    schoolClassModule.fetchGrades();
    schoolClassModule.fetchSchoolClasses();
    await schoolClassModule.fetchGradesSchoolClasses();
    jgrowEventCreateModule.resetSchoolClassSelection(schoolClassModule.gradeSchoolClasses); //組ラベルセット
    await activityModule.fetchActivities();

    //更新タイプ別に処理を変更
    switch (jgrowEventCreateModule.mode) {
      case GEnum.JgrowEventPageMode.Create:
        this.title = '新規作成';
        this.evalSettingDetail.questionSettingType = masterModule.questionTypes[0].questionTypeID;
        jgrowEventCreateModule.setCompetencySelections(masterModule.competencies.filter((d: Competency) => jgrowEventCreateModule.jgrowEventBasicCompetencyIds.includes(d.competencyID))); // デフォルトは決められた18種類
        jgrowEventCreateModule.setActivitySelections(activityModule.activities.filter((act: Activity) => act)); // デフォルトは全てのアクティビティ
        schoolClassModule.setGradeSchoolClassesIncludeSelected();
        break;

      case GEnum.JgrowEventPageMode.Edit:
        this.evalSettingDetail.questionSettingType = masterModule.questionTypes[0].questionTypeID;
        // イベント情報の取得・保持
        await jgrowEventCreateModule.fetchEvent(this.eventID);
        // 保持した作成済みイベント情報から、イベント作成・編集用データへのコピー
        jgrowEventCreateModule.setEventParam();
        // 取得したイベント情報からタイトルを取得
        this.title = `編集【${jgrowEventCreateModule.createdEvent.eventName}】`;
        // 全てのアクティビティを保持
        jgrowEventCreateModule.setActivitySelections(activityModule.activities.filter((act: Activity) => act)); // デフォルトは全てのアクティビティ
        // 選択済みのアクティビティをセット
        jgrowEventCreateModule.setActivitySelected(jgrowEventCreateModule.createdEvent.activities.map((actID: number) => activityModule.toActivity(actID)));
        // 選択済みコンピテンシーをセット
        jgrowEventCreateModule.setCompetencySelections(jgrowEventCreateModule.createdEvent.competencies.map((competencyID: number) => masterModule.toCompetency(competencyID)));
        // クラスID が存在する場合、クラス単位での選択
        if (jgrowEventCreateModule.createdEvent.schoolClassIDs.length > 0) {
          jgrowEventCreateModule.setSchoolClassSelection(schoolClassModule.schoolClasses.filter((sc: SchoolClass) => jgrowEventCreateModule.createdEvent.schoolClassIDs.includes(sc.schoolClassID))); // クラスID を元に スクールクラスを設定
          schoolClassModule.setGradeSchoolClassesIncludeSelected(schoolClassModule.schoolClasses.filter((sc: SchoolClass) => jgrowEventCreateModule.createdEvent.schoolClassIDs.includes(sc.schoolClassID))); //学年クラスデータにチェックボックスグループの値を反映
          jgrowEventCreateModule.setExamnieeSelectionType(GEnum.ExamineeSelectionType.Class);
        } else {
          // 生徒単位での選択の場合
          jgrowEventCreateModule.setAlreadyAssignedStudentIDs(jgrowEventCreateModule.createdEvent.students);
          jgrowEventCreateModule.setExamnieeSelectionType(GEnum.ExamineeSelectionType.Student);
        }
        break;
      default:
    }

    //設問タイプに有効なコンピテンシーをセット
    const competenciesIncludeIsValid: Competency[] = masterModule.competenciesByQuestionTypeID(this.evalSettingDetail.questionSettingType);
    masterModule.setCompetenciesIncludeIsValid(competenciesIncludeIsValid);

    this.breadCrumbItems = [{ title: 'ホーム', icon: 'ios-home', routerPath: '/pages/home' }, { title: 'イベント' }, { title: this.title }];

    this.lazy = true;
  }

  get mode(): number {
    return jgrowEventCreateModule.mode;
  }

  get questionTypes(): QuestionType[] {
    return masterModule.questionTypes;
  }

  get competencyIDs(): number[] {
    return masterModule.competencyIDs;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get currentStep(): number {
    return jgrowEventCreateModule.currentStep;
  }

  get evalSettingModeCreate(): boolean {
    return jgrowEventCreateModule.mode === GEnum.EvalSettingMode.Create;
  }

  get evalSettingModeEdit(): boolean {
    return jgrowEventCreateModule.mode === GEnum.EvalSettingMode.Edit;
  }

  get evalSettingModeCopy(): boolean {
    return jgrowEventCreateModule.mode === GEnum.EvalSettingMode.Copy;
  }

  get visitConfirmView(): boolean {
    return jgrowEventCreateModule.visitConfirmView;
  }

  get currentBaseSetting(): boolean {
    return this.currentStep === GEnum.ExamCreateStepWithoutGiftCourseMail.BaseSettingStep;
  }

  get currentQuestionSetting(): boolean {
    return this.currentStep === GEnum.ExamCreateStepWithoutGiftCourseMail.QuestionSettingStep;
  }

  get currentExamineeSetting(): boolean {
    return this.currentStep === GEnum.ExamCreateStepWithoutGiftCourseMail.ExamineeSettingStep;
  }

  get currentConfirmView(): boolean {
    return this.currentStep === GEnum.ExamCreateStepWithoutGiftCourseMail.ConfirmViewStep;
  }

  get isAutoPageTransition(): boolean {
    return jgrowEventCreateModule.isAutoPageTransition;
  }

  isValid(): boolean {
    const { baseSetting, questionSetting, examineeSetting }: any = this.$refs;
    if (this.currentBaseSetting && !baseSetting.isValid) {
      return false;
    } else if (this.currentQuestionSetting && !questionSetting.isValid) {
      return false;
    } else if (this.currentExamineeSetting && !examineeSetting.isValid && !this.evalSettingModeEdit) {
      return false;
    }
    return true;
  }

  openConfirm(ok: () => void, cancel: () => void) {
    let config = {
      title: `現在の設定内容が失われますがよろしいでしょうか？`,
      width: 500,
      onOk: () => {
        ok();
      },
      onCancel: () => {
        cancel();
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  handleReturn() {
    jgrowEventCreateModule.setCurrentStep(this.currentStep - 1);
  }
  handleNext() {
    if (!this.isValid()) {
      return;
    }
    jgrowEventCreateModule.setCurrentStep(this.currentStep + 1);
  }
  handleConfirmReturn() {
    if (!this.isValid()) {
      return;
    }
    jgrowEventCreateModule.setCurrentStep(GEnum.ExamCreateStepWithoutGiftCourseMail.ConfirmViewStep);
  }
}
